function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M82.422 50.112v-32.24c0-4.847-3.943-8.79-8.79-8.79H8.79C3.943 9.082 0 13.025 0 17.872V61.23c0 4.847 3.943 8.79 8.79 8.79h50.2c-.003.13-.006.26-.006.39 0 11.308 9.2 20.508 20.508 20.508S100 81.718 100 70.41c0-10.313-7.653-18.871-17.578-20.297zM8.789 14.942h64.844a2.933 2.933 0 012.93 2.93v1.757H5.859V17.87a2.933 2.933 0 012.93-2.93zM5.86 25.487h70.703v5.86H5.86v-5.86zM8.79 64.16a2.933 2.933 0 01-2.93-2.93V37.207h70.703v12.905C68.734 51.237 62.32 56.8 59.96 64.16H8.79zM79.492 85.06c-8.077 0-14.648-6.572-14.648-14.649 0-8.077 6.571-14.648 14.648-14.648s14.649 6.571 14.649 14.648S87.569 85.06 79.492 85.06z",
  fill: "currentColor"
});

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M83.768 65.018l-4.96 4.96-1.541-1.542a2.93 2.93 0 10-4.143 4.143l3.613 3.614a2.92 2.92 0 002.071.858c.75 0 1.5-.286 2.072-.858l7.031-7.032a2.93 2.93 0 00-4.143-4.143zM14.648 48.926h7.325a2.93 2.93 0 000-5.86h-7.325a2.93 2.93 0 000 5.86zM31.25 52.441H14.648a2.93 2.93 0 000 5.86H31.25a2.93 2.93 0 000-5.86z",
  fill: "currentColor"
});

var SvgCreditCardOutline = function SvgCreditCardOutline(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 100 100",
    fill: "none"
  }, props), _ref, _ref2);
};

export default SvgCreditCardOutline;